import React, { createContext, useContext, useState } from 'react';

const defaultDueDateContextValue = {
	dueDateStatus: null,
	setDueDateStatus: () => {},
	reqStatus: null,
	setReqStatus: () => {},
};

const DueDateContext = createContext(defaultDueDateContextValue);

export const useDueDate = () => useContext(DueDateContext) || defaultDueDateContextValue;

export const DueDateProvider = ({ children }) => {
	const [dueDateStatus, setDueDateStatus] = useState(null);
	const [reqStatus, setReqStatus] = useState(null);

	return (
		<DueDateContext.Provider
			value={{ dueDateStatus, setDueDateStatus, reqStatus, setReqStatus }}>
			{children}
		</DueDateContext.Provider>
	);
};
